'use client';
import { Children } from 'react';

/**
 * Фильтрует все `false`/`null`/`undefined`/`0` вхождения из набора `ReactNode`.
 * @param children Набор `ReactNode` для фильтрации.
 */ const filterFalsyChildren = (children)=>Children.toArray(children).filter(Boolean);

export { filterFalsyChildren };
//# sourceMappingURL=filterFalsyChildren.js.map
